const SessionStorageConst = {
    IsAuthenticated: 'isAuthenticated',
    Language: 'language'
}

export default SessionStorageConst;